import { CHANGE_EDITOR_FOCUS, SET_EDITOR_MODE } from './types'

const defaultState = {
  isFocused: false,
  mode: 'reply',
}

const reducers = {}

reducers[CHANGE_EDITOR_FOCUS] = (state, { payload: { isFocused } }) => {
  return {
    ...state,
    isFocused,
  }
}

reducers[SET_EDITOR_MODE] = (state, { payload: mode }) => {
  return {
    ...state,
    mode,
  }
}

export default function reducer(state = defaultState, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
